var scope_0 = require('/home/runner/work/doctocat/doctocat/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/190242104f89d4e0f11f38ed1753dbbe.js').default;
var scope_1 = require('/home/runner/work/doctocat/doctocat/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/1c71274f4992cca08bf46f5021211823.js').default;
var scope_2 = require('/home/runner/work/doctocat/doctocat/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/86ba6756d7ab94b4345eee20f2c5d9f7.js').default;
var scope_3 = require('/home/runner/work/doctocat/doctocat/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/8b107e976b29a0abf68dd4c39320d785.js').default;
var scope_4 = require('/home/runner/work/doctocat/doctocat/docs/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4 )
    